<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-account"
      icon-small
      title="لیست مدیران سایت"
      color="accent"
    >
      <template v-slot:topActons>
        <v-btn
          color="primary"
          dark
          @click="add"
        >
          <v-icon dark>
            mdi-plus-circle-outline
          </v-icon>
          افزودن کاربر
        </v-btn>
      </template>
      <v-row>
        <v-col
          cols="12"
          style="padding:0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="users"
                :items-per-page="500"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>{{ row.item.fullName }}</td>
                    <td>{{ row.item.userName }}</td>
                    <td>{{ row.item.email }}</td>
                    <td class="text-center">
                      {{ row.item.viewCount }}
                    </td>
                    <td class="text-center">
                      {{ `${row.item.lastLoginDate_Persian.date} ${row.item.lastLoginDate_Persian.time}` }}
                    </td>
                    <td class="text-center">
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="secondary"
                        @click="edit(row.item)"
                      >
                        <v-icon dark>
                          mdi-square-edit-outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="pink"
                        @click="remove(row.item)"
                      >
                        <v-icon dark>
                          mdi-trash-can-outline
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogUser"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">مشخصات کاربر</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <modify-user
                ref="modifyUser"
                :data="selectedUser"
                @callbck="callbck"
              />
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import ModifyUser from './ModifyUser.vue'

  export default {
    name: 'MembersView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'modify-user': ModifyUser,
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        selectedUser: {},
        dialogUser: false,
        search: '',
        headers: [
          {
            text: 'نام کاربر',
            align: 'start',
            sortable: true,
            value: 'fullName',
          }, {
            text: 'نام کاربری',
            align: 'start',
            sortable: true,
            value: 'userName',
          }, {
            text: 'ایمیل',
            align: 'start',
            sortable: true,
            value: 'email',
          }, {
            text: 'دفعات مراجعه',
            align: 'center',
            sortable: true,
            value: 'viewCount',
          }, {
            text: 'آخرین فعالیت',
            align: 'center',
            sortable: true,
            value: 'lastLoginDate_Persian',
          }, {
            text: 'عملیات ها',
            align: 'center',
            sortable: false,
            width: 150,
          },
        ],
        users: [],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        api.get('admin/user/list', null)
          .then(
            response => {
              this.users = response
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      add () {
        this.dialogUser = true
        this.selectedUser = { id: 0 }
        this.$nextTick(() => {
          this.$refs.modifyUser.prepareData()
        })
      },
      edit (item) {
        this.dialogUser = true
        this.selectedUser = item
        this.$nextTick(() => {
          this.$refs.modifyUser.prepareData()
        })
      },
      callbck (result) {
        this.dialogUser = false
        if (result) { this.loadData() }
      },
      async remove (item) {
        if (!item) { return }

        if (await this.$refs.confirm.open(
          'توجه',
          'آیا از حذف این آیتم مطمئن هستید؟',
        )) {
          api.post('admin/user/delete/' + item.id)
            .then(
              response => {
                toast.success('اطلاعات با موفقیت حذف شد.')
                this.loadData()
              })
            .catch(err => {
              toast.error(err.message)
            })
        }
      },
    },
  }
</script>
<style>
</style>
